import { render, staticRenderFns } from "./permissions-details.vue?vue&type=template&id=7a500712&scoped=true"
import script from "./permissions-details.vue?vue&type=script&lang=js"
export * from "./permissions-details.vue?vue&type=script&lang=js"
import style0 from "./permissions-details.vue?vue&type=style&index=0&id=7a500712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a500712",
  null
  
)

export default component.exports